import {
  type FindReplaceRule,
  IFindAndReplaceRuleType,
  type ISnippetRule,
} from '@carboncopyco/types';

export const isCustomCodeSnippetRule = (
  snippet: FindReplaceRule
): snippet is ISnippetRule => {
  return snippet.type === IFindAndReplaceRuleType.snippet;
};
